import { render, staticRenderFns } from "./TermsOfServiceView.vue?vue&type=template&id=22890040"
import script from "./TermsOfServiceView.vue?vue&type=script&lang=js"
export * from "./TermsOfServiceView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports